var _rect, _rect2, _path, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _rect7, _path5, _rect8, _circle, _rect9, _rect10, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 180,
    viewBox: "0 0 200 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.6084,
    y: 85.8745,
    width: 64,
    height: 73.0159,
    rx: 5,
    transform: "rotate(-30 -1.6084 85.8745)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 4.49365,
    y: 87.4834,
    width: 55.04,
    height: 64.127,
    rx: 4,
    transform: "rotate(-30 4.49365 87.4834)",
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5908 64.9337C28.4967 66.4521 27.949 68.3993 26.3674 69.283C24.7858 70.1666 22.7694 69.6521 21.8635 68.1337C20.9577 66.6153 21.5054 64.6681 23.087 63.7844C24.6685 62.9008 26.685 63.4153 27.5908 64.9337ZM26.4455 65.5736C26.989 66.4847 26.6604 67.653 25.7114 68.1832C24.7625 68.7134 23.5526 68.4047 23.0091 67.4936C22.4656 66.5826 22.7943 65.4142 23.7432 64.8841C24.6921 64.3539 25.902 64.6626 26.4455 65.5736Z",
    fill: "#DFE1F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2954,
    y: 76.2251,
    width: 32,
    height: 9.52381,
    rx: 3,
    transform: "rotate(-30 11.2954 76.2251)",
    fill: "#DFE1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4458 88.0199C38.021 87.6986 38.7572 87.8908 39.0903 88.4491L41.503 92.4932C41.8362 93.0516 41.64 93.7648 41.0649 94.0861C40.4898 94.4074 39.7535 94.2153 39.4204 93.6569L37.0077 89.6128C36.6746 89.0544 36.8707 88.3413 37.4458 88.0199ZM31.2909 95.8034C31.4621 95.1813 32.1214 94.813 32.7636 94.9806L37.4176 96.1952C38.0598 96.3629 38.4417 97.003 38.2706 97.6251C38.0995 98.2471 37.4401 98.6155 36.7979 98.4479L32.144 97.2332C31.5017 97.0656 31.1198 96.4254 31.2909 95.8034ZM47.4886 86.7534C48.1308 86.921 48.5127 87.5611 48.3416 88.1832L47.1016 92.6909C46.9305 93.313 46.2712 93.6813 45.629 93.5137C44.9867 93.3461 44.6048 92.706 44.7759 92.0839L46.0159 87.5762C46.187 86.9541 46.8464 86.5857 47.4886 86.7534ZM37.6446 103.108C37.9611 102.535 38.4366 102.059 39.0177 101.734L48.9317 96.1944C49.513 95.87 50.1773 95.7091 50.8486 95.7305C51.5193 95.7519 52.1712 95.9541 52.7309 96.3143L52.7325 96.3153L60.4779 101.272C60.6342 101.372 60.7644 101.506 60.8581 101.663L64.4772 107.729C64.9571 108.534 65.0882 109.489 64.8417 110.385C64.5952 111.281 63.9913 112.045 63.1627 112.508L46.5014 121.817C45.6729 122.28 44.6877 122.404 43.7625 122.163C42.8372 121.921 42.0478 121.334 41.5679 120.529L37.9489 114.463C37.8551 114.306 37.8004 114.13 37.789 113.949L37.226 104.979L37.2258 104.977C37.1834 104.328 37.3284 103.681 37.6446 103.108ZM40.2251 103.755C40.0314 103.863 39.8729 104.022 39.7674 104.213C39.6619 104.404 39.6136 104.62 39.6279 104.837L39.6281 104.84L40.073 111.928L44.635 109.379C44.9832 109.185 45.4091 109.172 45.77 109.345L49.0845 110.937L52.1352 109.233L52.3678 105.659C52.3931 105.27 52.6175 104.919 52.9657 104.725L57.5276 102.176L51.4073 98.2591L51.4042 98.2572C51.2175 98.1369 51 98.0694 50.7763 98.0622C50.5525 98.0551 50.3313 98.1086 50.1375 98.2168L40.2251 103.755ZM59.3787 103.838L54.7293 106.435L54.4967 110.009C54.4714 110.398 54.247 110.749 53.8989 110.944L49.7336 113.271C49.3854 113.465 48.9595 113.478 48.5985 113.305L45.2841 111.713L40.6347 114.311L43.6506 119.366C43.8106 119.634 44.0737 119.83 44.3821 119.91C44.6905 119.991 45.0189 119.949 45.2951 119.795L61.9564 110.486C62.2326 110.331 62.4339 110.077 62.516 109.778C62.5982 109.48 62.5545 109.161 62.3945 108.893L59.3787 103.838Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 73.0159,
    rx: 5,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 200.934 85.8745)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 55.04,
    height: 64.127,
    rx: 4,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 194.832 87.4834)",
    fill: "#F1F1F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.734 64.9337C170.828 66.4521 171.376 68.3993 172.958 69.283C174.539 70.1666 176.556 69.6521 177.462 68.1337C178.368 66.6153 177.82 64.6681 176.238 63.7844C174.657 62.9008 172.64 63.4153 171.734 64.9337ZM172.88 65.5736C172.336 66.4847 172.665 67.653 173.614 68.1832C174.563 68.7134 175.773 68.4047 176.316 67.4936C176.86 66.5826 176.531 65.4142 175.582 64.8841C174.633 64.3539 173.423 64.6626 172.88 65.5736Z",
    fill: "#DFE1F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 9.52381,
    rx: 3,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 188.03 76.2251)",
    fill: "#DFE1F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.879 88.0199C161.304 87.6986 160.568 87.8908 160.235 88.4491L157.822 92.4932C157.489 93.0516 157.685 93.7648 158.26 94.0861C158.835 94.4074 159.572 94.2153 159.905 93.6569L162.318 89.6128C162.651 89.0544 162.454 88.3413 161.879 88.0199ZM168.034 95.8034C167.863 95.1813 167.204 94.813 166.562 94.9806L161.908 96.1952C161.265 96.3629 160.884 97.003 161.055 97.6251C161.226 98.2471 161.885 98.6155 162.527 98.4479L167.181 97.2332C167.823 97.0656 168.205 96.4254 168.034 95.8034ZM151.837 86.7534C151.194 86.921 150.812 87.5611 150.984 88.1832L152.224 92.6909C152.395 93.313 153.054 93.6813 153.696 93.5137C154.338 93.3461 154.72 92.706 154.549 92.0839L153.309 87.5762C153.138 86.9541 152.479 86.5857 151.837 86.7534ZM161.681 103.108C161.364 102.535 160.889 102.059 160.308 101.734L150.394 96.1944C149.812 95.87 149.148 95.7091 148.477 95.7305C147.806 95.7519 147.154 95.9541 146.594 96.3143L146.593 96.3153L138.847 101.272C138.691 101.372 138.561 101.506 138.467 101.663L134.848 107.729C134.368 108.534 134.237 109.489 134.483 110.385C134.73 111.281 135.334 112.045 136.162 112.508L152.824 121.817C153.652 122.28 154.638 122.404 155.563 122.163C156.488 121.921 157.277 121.334 157.757 120.529L161.376 114.463C161.47 114.306 161.525 114.13 161.536 113.949L162.099 104.979L162.099 104.977C162.142 104.328 161.997 103.681 161.681 103.108ZM159.1 103.755C159.294 103.863 159.452 104.022 159.558 104.213C159.663 104.404 159.712 104.62 159.697 104.837L159.697 104.84L159.252 111.928L154.69 109.379C154.342 109.185 153.916 109.172 153.555 109.345L150.241 110.937L147.19 109.233L146.957 105.659C146.932 105.27 146.708 104.919 146.36 104.725L141.798 102.176L147.918 98.2591L147.921 98.2572C148.108 98.1369 148.325 98.0694 148.549 98.0622C148.773 98.0551 148.994 98.1086 149.188 98.2168L159.1 103.755ZM139.947 103.838L144.596 106.435L144.828 110.009C144.854 110.398 145.078 110.749 145.426 110.944L149.592 113.271C149.94 113.465 150.366 113.478 150.727 113.305L154.041 111.713L158.69 114.311L155.675 119.366C155.515 119.634 155.252 119.83 154.943 119.91C154.635 119.991 154.306 119.949 154.03 119.795L137.369 110.486C137.093 110.331 136.891 110.077 136.809 109.778C136.727 109.48 136.771 109.161 136.931 108.893L139.947 103.838Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46,
    width: 88,
    height: 103,
    rx: 5,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.094 41.2063C104.094 43.5295 102.058 45.4127 99.5472 45.4127C97.0361 45.4127 95.0005 43.5295 95.0005 41.2063C95.0005 38.8832 97.0361 37 99.5472 37C102.058 37 104.094 38.8832 104.094 41.2063ZM102.275 41.2063C102.275 42.6002 101.054 43.7302 99.5475 43.7302C98.0409 43.7302 96.8195 42.6002 96.8195 41.2063C96.8195 39.8125 98.0409 38.6825 99.5475 38.6825C101.054 38.6825 102.275 39.8125 102.275 41.2063Z",
    fill: "#DFE1F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 43.73,
    width: 44,
    height: 12.619,
    rx: 3,
    fill: "#DFE1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.669,
    cy: 106.669,
    r: 33,
    transform: "rotate(-45 100.669 106.669)",
    fill: "#7ABCFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 121.492,
    y: 138.392,
    width: 14,
    height: 36.1374,
    rx: 4,
    transform: "rotate(-45 121.492 138.392)",
    fill: "#7ABCFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 121.932,
    y: 131.75,
    width: 4,
    height: 7.2299,
    transform: "rotate(-45 121.932 131.75)",
    fill: "#7ABCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 94L113 119",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113 94L88 119",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsEmpty);
export default __webpack_public_path__ + "static/media/results-empty.cceeb565.svg";
export { ForwardRef as ReactComponent };